import { useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createSaasQueryClient } from '../saas/lib/queryClient';

/**
 * Shared TanStack Query root for the T&B site.
 *
 * The SaaS tree already mounts QueryClientProvider in SaasPublicProviders.
 * T&B still renders the same workspace components (Ava brief, availability,
 * live track, currency/timezone selects), so it needs the same client or
 * every one of those hooks throws "No QueryClient set".
 */
export default function AppQueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createSaasQueryClient);
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
